import { Mtds } from 'prove-common'

type DelegationCardProgressProps = {
  samplesTaken: number
  quantity: number
}

/**
 * «X prøver tatt» / «Y gjenstår» med framdriftsindikator, delt av alle kortene.
 */
export const DelegationCardProgress = ({
  samplesTaken,
  quantity
}: Readonly<DelegationCardProgressProps>) => {
  const remaining = Math.max(quantity - samplesTaken, 0)
  return (
    <Mtds.Grid data-gap={2}>
      <Mtds.Flex data-justify='space-between' data-align='center' data-gap={3}>
        <span>
          <strong>{samplesTaken}</strong> prøver tatt
        </span>
        <span>
          <strong>{remaining}</strong> gjenstår
        </span>
      </Mtds.Flex>
      <Mtds.Progress
        aria-label={`${samplesTaken} av ${quantity} prøver tatt`}
        value={Math.min(samplesTaken, quantity)}
        max={Math.max(quantity, 1)}
      />
    </Mtds.Grid>
  )
}
